export default "__VITE_ASSET__BBCWIWEl__"